interface RemarksTextareaProps {
  value: string;
  onChange?: (value: string) => void;
}

const RemarksTextarea: React.FC<RemarksTextareaProps> = ({ value, onChange }) => {
  return (
    <div className="relative w-full">
      <textarea
        value={value}
        disabled
        onChange={(e) => onChange(e.target.value)}
        className="w-full text-sm text-[#6C727F] leading-2 border border-[#E4E7EC] rounded-xl p-4 pt-7 bg-white focus:outline-none focus:ring-1 focus:ring-blue-400 "
      />

      <span className="absolute top-2 left-4 text-xs font-medium text-[#ff540b] pointer-events-none">Remarks</span>
    </div>
  );
};

export default RemarksTextarea;
